import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { authApi } from './auth';

export const supportStaffApi = createApi({
    reducerPath: 'supportStaffApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/support-staff",
    }),
    tagTypes: ["SupportStaff"],
    endpoints: (builder) => ({
        getTaskPlanList: builder.query({
            query: ({ page = 1, limit = 10, client_type, status = "", school = "", search = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `/task_plan_lists`,
                data: { page, limit, sort, search, client_type: client_type?.value, status: status?.value, school: school?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),
        getSingleTaskPlan: builder.query({
            query: ({ id, clientId }) => ({
                method: "GET",
                url: `/task_plan_detail/${id}/${clientId}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["SupportStaff"]
        }),
    }),
})

export const {
    useGetTaskPlanListQuery,
    useGetSingleTaskPlanQuery
} = supportStaffApi;